import CampaignTemplatesPage from "./CampaignTemplatesPage";

export default CampaignTemplatesPage;
